import React from "react";
import Modal from "react-modal";
import AboutModal from "./AboutModal";
import AuthenticationModal from "../authentication/AuthenticationModal";
import UploadModal from "../upload/UploadModal";
import ProfileModal from "../user/ProfileModal";

const modalStyles = () => {
  if (window.innerWidth >= "600") {
    return {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        padding: "0",
      },
    };
  } else {
    return {
      content: {
        top: "0%",
        left: "0%",
        right: "0%",
        bottom: "0%",
        padding: "0",
      },
    };
  }
};

Modal.setAppElement("#root");

const ModalContainer = ({
  currentUser,
  currentUserAvatar,
  errors,
  loggedIn,
  login,
  logout,
  modal,
  modalIsOpen,
  posts,
  setCurrentUserAvatar,
  setErrors,
  setNotificationId,
  setIsOpen,
  setLocationMode,
  setPostId,
  setPosts,
  setSelected,
}) => {
  const closeModal = () => {
    setIsOpen(false);
    setErrors({});
  };

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={true}
        style={modalStyles()}
      >
        {!loggedIn ? (
          <>
            {modal === "login" && (
              <AuthenticationModal
                closeModalAfterAuthentication={closeModal}
                errors={errors}
                login={login}
                setErrors={setErrors}
              />
            )}
          </>
        ) : (
          <>
            {modal === "upload" && (
              <UploadModal
                closeModalAfterUpload={closeModal}
                errors={errors}
                setErrors={setErrors}
                setLocationMode={setLocationMode}
                setNotificationId={setNotificationId}
                setPostId={setPostId}
                setPosts={setPosts}
                setSelected={setSelected}
              />
            )}
            {modal === "profile" && (
              <ProfileModal
                closeModalAfterUpload={closeModal}
                currentUser={currentUser}
                currentUserAvatar={currentUserAvatar}
                errors={errors}
                logout={logout}
                posts={posts}
                setCurrentUserAvatar={setCurrentUserAvatar}
                setErrors={setErrors}
                setPosts={setPosts}
              />
            )}
          </>
        )}
        {modal === "about" && <AboutModal closeModal={closeModal} />}
      </Modal>
    </>
  );
};

export default ModalContainer;
